import { Cpu, Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function ModelSelector() {
  const [selectedModel, setSelectedModel] = useState("gpt-4");

  // todo: remove mock functionality
  const models = [
    {
      id: "gpt-4",
      name: "GPT-4 Turbo",
      provider: "OpenAI",
      description: "Most capable model for complex reasoning and analysis",
      credits: 5,
      features: ["Advanced reasoning", "128K context", "Vision support"],
    },
    {
      id: "claude-3",
      name: "Claude 3 Opus",
      provider: "Anthropic",
      description: "Excellent for nuanced analysis and creative tasks",
      credits: 5,
      features: ["Long context", "Careful reasoning", "200K context"],
    },
    {
      id: "perplexity",
      name: "Perplexity AI",
      provider: "Perplexity",
      description: "Real-time web search and research capabilities",
      credits: 3,
      features: ["Web search", "Citations", "Real-time data"],
    },
    {
      id: "gpt-3.5",
      name: "GPT-3.5 Turbo",
      provider: "OpenAI",
      description: "Fast and efficient for most general tasks",
      credits: 1,
      features: ["Fast responses", "Cost effective", "16K context"],
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">LLM Model Selector</h1>
        <p className="text-muted-foreground">Choose different AI models for your queries (like Perplexity's model picker)</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {models.map((model) => (
          <Card
            key={model.id}
            className={`p-6 cursor-pointer transition-all ${
              selectedModel === model.id ? "border-primary border-2" : "hover-elevate"
            }`}
            onClick={() => setSelectedModel(model.id)}
            data-testid={`model-${model.id}`}
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Cpu className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">{model.name}</h3>
                  <p className="text-sm text-muted-foreground">{model.provider}</p>
                </div>
              </div>
              {selectedModel === model.id && (
                <div className="p-1 bg-primary rounded-full">
                  <Check className="h-4 w-4 text-primary-foreground" />
                </div>
              )}
            </div>
            <p className="text-sm text-muted-foreground mb-4">{model.description}</p>
            <div className="flex items-center justify-between">
              <div className="flex gap-1 flex-wrap">
                {model.features.slice(0, 2).map((feature, index) => (
                  <Badge key={index} variant="secondary" className="text-xs">
                    {feature}
                  </Badge>
                ))}
              </div>
              <span className="text-sm font-medium">{model.credits} credits/query</span>
            </div>
          </Card>
        ))}
      </div>

      <div className="flex justify-end">
        <Button data-testid="button-save-model">Save Selection</Button>
      </div>
    </div>
  );
}
